import React from "react";
import Bezorgen from "shared/ui/icons/Bezorgen";
import Fabriek from "shared/ui/icons/Fabriek";
import GeldTerug from "shared/ui/icons/GeldTerug";
import Text from "shared/ui/typography/Text";
import { USPListItemType } from "shared/utils/usps";

interface USPHeaderListProps {
  uspList: USPListItemType;
}

export const AcousticPanelUSPList: React.FC<USPHeaderListProps> = React.memo(
  ({ uspList }) => {
    return (
      <div>
        <ul className="gg-pt-5 gg-grid gg-gap-y-2 ">
          {Object.values(uspList).map((usp, index) => (
            <li key={index} className="gg-flex lg:gg-items-center gg-gap-x-2.5">
              {index === 0 ? (
                <Fabriek />
              ) : index === 1 ? (
                <Bezorgen />
              ) : (
                <GeldTerug />
              )}
              <Text className="gg-text-slate-800 gg-text-sm gg-leading-6 gg-w-full">
                {usp}
              </Text>
            </li>
          ))}
        </ul>
      </div>
    );
  }
);
